import { type ForwardRefExoticComponent, forwardRef } from 'react';

import { ProgressStepperBar } from './progress-stepper-bar';
import { ProgressStepperRoot } from './progress-stepper-root';
import { ProgressStepperStep } from './progress-stepper-step';
import { ProgressStepperSteps } from './progress-stepper-steps';
import type { ProgressStepperPropsInterface } from './types/progress-stepper.types';

/**
 * Shorthand Progress component
 *
 * @related ['ProgressBar']
 * @since 8.42.0
 */
export const ProgressStepper = forwardRef<HTMLDivElement, ProgressStepperPropsInterface>(
  (props: ProgressStepperPropsInterface, forwardedRef) => {
    return (
      <ProgressStepper.Root ref={forwardedRef} {...props}>
        <ProgressStepper.Bar />
        <ProgressStepper.Steps />
      </ProgressStepper.Root>
    );
  },
) as ForwardRefExoticComponent<ProgressStepperPropsInterface> & {
  Bar: typeof ProgressStepperBar;
  Root: typeof ProgressStepperRoot;
  Step: typeof ProgressStepperStep;
  Steps: typeof ProgressStepperSteps;
};

ProgressStepper.Root = ProgressStepperRoot;
ProgressStepper.Bar = ProgressStepperBar;
ProgressStepper.Step = ProgressStepperStep;
ProgressStepper.Steps = ProgressStepperSteps;

ProgressStepper.displayName = 'ProgressStepper';
